import { render, staticRenderFns } from "./TheCallHistory.vue?vue&type=template&id=72a2be96&scoped=true"
import script from "./TheCallHistory.vue?vue&type=script&lang=js"
export * from "./TheCallHistory.vue?vue&type=script&lang=js"
import style0 from "./TheCallHistory.vue?vue&type=style&index=0&id=72a2be96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a2be96",
  null
  
)

export default component.exports